import gql from 'graphql-tag';
// price fragments are needed in HitInfo component because it calls "hasPriceSecondary" check
// which requires price data
import {fragments as priceFragments} from '../Price/Price';
import {hitInfoDesktopFragments} from './HitInfoDesktop.fragments';
import {hitInfoMobileFragments} from './HitInfoMobile.fragments';

// HitInfo only renders HitInfoMobile and HitInfoDesktop components

export const hitInfoFragments = {
    Listing: gql`
        fragment HitInfoListing on Listing {
            listingId
            ...HitInfoDesktopListing
            ...HitInfoMobileListing
            ...PriceListing
        }
        ${hitInfoDesktopFragments.Listing}
        ${hitInfoMobileFragments.Listing}
        ${priceFragments.Listing}
    `
};
